import React, { Component } from "react";
import { setNeighbourhood } from "../../../actions/Map/navActions";
import { connect } from "react-redux";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import MapBox from "./MapBox/MapBox";
import Loader from "../../Loader/Loader";
import styles from "./Map.scss";
import {
	getNeighbourhoods,
	getNeighbourhoodsColours
} from "../../../actions/Map/dataActions";
import NeighbourhoodTemplate from "../Neighbourhood/NeighbourhoodTemplate";

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      neighbourhoods: undefined
    };
  }

  componentDidMount() {
    this.props.getNeighbourhoods();
    this.props.getNeighbourhoodsColours();
    if (this.props.neighbourhoods !== []) {
      this.getDataFromURL();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.neighbourhoods !== this.props.neighbourhoods) {
      this.getDataFromURL();
    }
    if (
      prevProps.selected_neighbourhood !== this.props.selected_neighbourhood
    ) {
      if (this.props.selected_neighbourhood === undefined) {
        this.props.history.push("/map");
      } else {
        let newQuery = "/map/?id=" + this.props.selected_neighbourhood;
        this.props.history.push(newQuery);
      }
    }
  }

  getDataFromURL = () => {
    // Get id from query string if possible
    var queryString = this.props.location.search;
    if (queryString !== undefined) {
      queryString = queryString.replace("?", "");
      const queryArray = queryString.split("&");
      for (var i = 0; i < queryArray.length; i++) {
        let pair = queryArray[i].split("=");
        if (pair[0] === "id") {
          // setTimeout(() => {this.props.setNeighbourhood(pair[1])}, 3000);
          this.props.setNeighbourhood(pair[1]);
        }
      }
    } else {
      setTimeout(() => {
        this.props.setNeighbourhood(undefined);
      }, 3000);
    }
  };

  componentWillUnmount() {
    this.props.setNeighbourhood(undefined);
  }

  render() {
    return (
      <div className={styles.Map}>
        {this.props.selected_neighbourhood &&
          this.props.selected_neighbourhood_name &&
          this.props.selected_neighbourhood_url &&
          this.props.selected_neighbourhood_desc && (
            <div className={styles.DetailsBox}>
              <div className={styles.DetailsCard}>
                <FontAwesomeIcon
                  className={classNames(styles["close-icon"])}
                  size="2x"
                  icon={faTimes}
                  onClick={() => this.props.setNeighbourhood(undefined)}
                />

                <NeighbourhoodTemplate
                  id={this.props.selected_neighbourhood}
                  name={this.props.selected_neighbourhood_name}
                  url={this.props.selected_neighbourhood_url}
                  desc={this.props.selected_neighbourhood_desc}
                />
              </div>
              {!this.props.selected_neighbourhood_name && <Loader />}
            </div>
          )}
        <div className={styles.MapBox}>
          <MapBox />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    display_map: state.nav.display_map,
    neighbourhoods: state.nav.neighbourhoods,
    selected_neighbourhood: state.nav.selected_neighbourhood,
    selected_neighbourhood_name: state.nav.selected_neighbourhood_name,
    selected_neighbourhood_desc: state.nav.selected_neighbourhood_desc,
    selected_neighbourhood_url: state.nav.selected_neighbourhood_url,
    colours: state.nav.colours
  };
}

const actions = { setNeighbourhood, getNeighbourhoodsColours, getNeighbourhoods };

export default connect(
  mapStateToProps,
  actions
)(Map);



// WEBPACK FOOTER //
// ./src/components/pages/Map/Map.js